/**
 * @Author: zhangxiaojian
 * @Date: 2025/5/27
 * @LastEditors: zhangxiaojian
 * @Description 打包后对createAPI、requestCommonAPI方法中的url参数进行加密处理，如需在此文件中对url进行二次处理，请先调用decryptUrl解密
 **/

import { createAPI } from '@common'

/**
 * 对api请求进行二次封装，注意：因在打包后会对url进行加密处理在该方法内请勿直接操作url，如需操作可引用common中decryptUrl先进行解密再操作
 * @param url
 * @param action
 * @param config
 * @returns {*}
 */
const requestCommonAPI = function (url, action, config) {
  return createAPI(url, action, config, {
    isClueDig: true,
    hub: '/v1/repository/hub'
  })
}
export default {
  getRRSites: (config) => createAPI('customEncryptApiName-1/0w20ss0tjuft', 'get', config),
  // 新建指令
  postCommandSender: (config) =>
    createAPI('customEncryptApiName-1/0w20ss0dpnnboe0tfoefs', 'post', config),
  // 修改
  putCommandSender: (config) =>
    createAPI('customEncryptApiName-1/0w20ss0dpnnboe0tfoefs', 'put', config),
  getSites: (config) => createAPI('customEncryptApiName-1/0w20ss0tjuft', 'get', config),
  // 获取指令详情
  getRRCommandSenderDetail: (config) =>
    createAPI('customEncryptApiName-1/0w20ss0dpnnboe0tfoefs0efubjm', 'get', config),
  postRRCommandSenderpublish: (config) =>
    createAPI('customEncryptApiName-1/0w20ss0dpnnboe0tfoefs0qvcmjti', 'post', config),
  // 复制指令
  postRRCommandSenderCopy: (config) =>
    createAPI('customEncryptApiName-1/0w20ss0dpnnboe0tfoefs0dpqz', 'post', config),
  postCommandSenderpublish: (config) =>
    createAPI('customEncryptApiName-1/0w20ss0dpnnboe0tfoefs0gbtuQvcmjti', 'post', config),
  // 文章列表
  postQueryMedia: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0rvfsz0nfejb', 'post', config),
  // 文章详情
  postFtsDocument: (config) =>
    requestCommonAPI('customEncryptApiName-1/0bqj0gut0epdvnfou', 'post', config)
}
